import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import SidebarMenu from "./AdminPanel/SidebarMenu";
import TopBar from "./AdminPanel/TopBar";

import useAccountsController from "./AccountsForm/useAccountsController";
import AccountsView from "./AccountsForm/AccountsView";

const AdminAccounts = () => {
  const navigate = useNavigate();

  const {
    open,
    setOpen,
    submenuOpen,
    setSubmenuOpen,
    accounts,
    loading,
    expandedSet,
    isAllExpanded,
    childrenByParent,
    hasChildren,
    toggleNode,
    toggleExpandAll,
    menuAnchorEl,
    openMenuFor,
    closeMenu,
    selectedAccount,
    canDeleteSelected,
    canEditSelected,
    canAddToSelected,
    openAddDialog,
    openEditDialog,
    openDeleteDialog,
    editorOpen,
    editorMode,
    formCode,
    formName,
    setFormName,
    formType,
    setFormType,
    formBalance,
    setFormBalance,
    balanceDisabled,
    typeDisabled,
    closeEditor,
    saveEditor,
    deleteOpen,
    closeDelete,
    confirmDelete,
    snackbarOpen,
    snackbarType,
    snackbarMessage,
    closeSnackbar,
    displayBalanceById,
  } = useAccountsController(navigate);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#edf0f7ff" }}>
      <SidebarMenu open={open} submenuOpen={submenuOpen} setSubmenuOpen={setSubmenuOpen} navigate={navigate} />

      <Box sx={{ flexGrow: 1, transition: "all 0.3s ease" }}>
        <TopBar open={open} setOpen={setOpen} />

        <AccountsView
          accounts={accounts}
          loading={loading}
          expandedSet={expandedSet}
          isAllExpanded={isAllExpanded}
          childrenByParent={childrenByParent}
          hasChildren={hasChildren}
          toggleNode={toggleNode}
          toggleExpandAll={toggleExpandAll}
          menuAnchorEl={menuAnchorEl}
          openMenuFor={openMenuFor}
          closeMenu={closeMenu}
          selectedAccount={selectedAccount}
          canDeleteSelected={canDeleteSelected}
          canEditSelected={canEditSelected}
          canAddToSelected={canAddToSelected}
          openAddDialog={openAddDialog}
          openEditDialog={openEditDialog}
          openDeleteDialog={openDeleteDialog}
          editorOpen={editorOpen}
          editorMode={editorMode}
          formCode={formCode}
          formName={formName}
          setFormName={setFormName}
          formType={formType}
          setFormType={setFormType}
          formBalance={formBalance}
          setFormBalance={setFormBalance}
          balanceDisabled={balanceDisabled}
          typeDisabled={typeDisabled}
          closeEditor={closeEditor}
          saveEditor={saveEditor}
          deleteOpen={deleteOpen}
          closeDelete={closeDelete}
          confirmDelete={confirmDelete}
          snackbarOpen={snackbarOpen}
          snackbarType={snackbarType}
          snackbarMessage={snackbarMessage}
          closeSnackbar={closeSnackbar}
          displayBalanceById={displayBalanceById}
        />
      </Box>
    </Box>
  );
};

export default AdminAccounts;